var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstaShareIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.39931 8.51724L12.8206 3.09784L9.24779 13.0676L7.39931 8.51724ZM11.9031 2.18291L6.48452 7.60231L1.93483 5.75356L11.9031 2.18291ZM0.588275 6.60371L6.14181 8.86L8.39776 14.4143C8.54078 14.7679 8.88619 15 9.26938 15C9.66606 15 10.0196 14.7517 10.1545 14.3766L14.9578 0.968407C15.0523 0.703915 14.9848 0.412433 14.7878 0.212715C14.5908 0.0129958 14.2967 -0.0517778 14.0323 0.0426838L0.623356 4.84673C0.248263 4.98167 0 5.33523 0 5.73197C0 6.11521 0.232072 6.46067 0.585577 6.60371H0.588275Z",
    fill: "#454545"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstaShareIcon);
export default __webpack_public_path__ + "static/media/InstaShareIcon.1dbf1d9413731a2a0f1aa4791e819ea6.svg";
export { ForwardRef as ReactComponent };